module.exports = __webpack_public_path__ + "img/radio.34ea971c.svg";